module.exports = __webpack_public_path__ + "img/icon-phone.6834ba69.svg";